import {ApplicationConfig} from '@angular/core';
/*import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { ProductService } from './service/product.service';
import { CountryService } from './service/country.service';
import { CustomerService } from './service/customer.service';
import { EventService } from './service/event.service';
import { IconService } from './service/icon.service';
import { NodeService } from './service/node.service';
import { PhotoService } from './service/photo.service';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import {ConfirmationService, MessageService} from "primeng/api";*/
import {Amplify} from "aws-amplify";
import awsconfig from '../aws-exports.js';
//import {QuillModule} from "ngx-quill";
import { provideQuillConfig } from 'ngx-quill'
import {provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling} from "@angular/router";
import {provideHttpClient, withFetch} from "@angular/common/http";
import {appRoutes} from "./app.routes";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {providePrimeNG} from "primeng/config";
import Aura from "@primeuix/themes/aura";
import {ConfirmationService, FilterMatchMode, MessageService} from "primeng/api";
//import {EditorLayoutModule} from "./layout/editor.layout.module";
//import {fetchAuthSession} from "aws-amplify/auth";

Amplify.configure(awsconfig);

export const appConfig: ApplicationConfig = {
    providers: [
        MessageService,
        ConfirmationService,
        provideRouter(appRoutes,
            withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
            withEnabledBlockingInitialNavigation()
        ),
        provideQuillConfig({
            //customModules: [{
            //  implementation: Counter,
            //  path: 'modules/counter'
            //}],
            customOptions: [{
              import: 'formats/font',
              whitelist: ['mirza', 'roboto', 'aref', 'serif', 'sansserif', 'monospace']
            }]
          }),
        provideHttpClient(withFetch()),
        provideAnimationsAsync(),
        providePrimeNG({
            ripple: true,
            inputVariant: 'outlined',
            filterMatchModeOptions: {
                text: [FilterMatchMode.STARTS_WITH, FilterMatchMode.CONTAINS, FilterMatchMode.NOT_CONTAINS, FilterMatchMode.ENDS_WITH, FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS],
                numeric: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS, FilterMatchMode.LESS_THAN, FilterMatchMode.LESS_THAN_OR_EQUAL_TO, FilterMatchMode.GREATER_THAN, FilterMatchMode.GREATER_THAN_OR_EQUAL_TO],
                date: [FilterMatchMode.DATE_IS, FilterMatchMode.DATE_IS_NOT, FilterMatchMode.DATE_BEFORE, FilterMatchMode.DATE_AFTER]
            },
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: '.app-dark'
                }
            }
        })
    ]
};

/*@NgModule({
    declarations: [AppComponent],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        AmplifyAuthenticatorModule,
        QuillModule.forRoot(),
        NotfoundComponent
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        CountryService, CustomerService, EventService, IconService, NodeService,
        PhotoService, ProductService, ConfirmationService, MessageService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }*/
